import React, { useEffect, useState } from 'react';
import { Link, Spinner } from '@xometry/xometry_loft';
import { css } from '@emotion/react';
import UserDisplay from '../UserDisplay';
import UserEditForm from '../UserEdit';
import usersApi from '../../../services/users';
import { useGetTargetUserData } from '../../../contexts/User/UserContext';

const user_block_panel_title = css`
  display: inline-block;
  font-weight: 600;
  margin-bottom: 12px;
  color: #253842;
  font-size: 16px;
  line-height: 24px;
`;
const userBlock__buttongroup__right = css`
  float: right;
  cursor: pointer;
  font-size: 14px;
  line-height: 20px;
  font-weight: 400 !important;
`;

// User Details used on Account Settings Page
const UserBlock = ({
  userID,
  onUserUpdate,
  staffMode,
  displayNotification,
}) => {
  const [mode, setMode] = useState('display');
  const [formValues, setFormValues] = useState({});
  const { userData: user, isLoading, error } = useGetTargetUserData();

  useEffect(() => {
    if (!isLoading && !error) {
      setFormValues({
        first_name: user.first_name,
        last_name: user.last_name,
        company_name: user.company_name,
        email_address: user.email_address,
        phone_number: user.phone_number,
        requireCompany: !!user.company,
        mfaMethod: user.mfa_method,
      });
    }
  }, [isLoading]);

  const showDisplay = () => {
    setMode('display');
  };

  const handleCancel = (e) => {
    e.preventDefault();
    showDisplay();
  };

  const showEdit = () => {
    setMode('edit');
  };

  const postUserDetails = (values, actions) => {
    const payload = {
      ...values,
    };
    delete payload['requireCompany'];

    return usersApi
      .postUserData(userID, payload)
      .then(() => {
        displayNotification('success', 'User Information Saved');
        onUserUpdate();
      })
      .catch((e) => {
        displayNotification(
          'danger',
          'This email address is already registered, please contact support@xometry.com if you need further assistance.'
        );
        actions.setFieldError('email_address', e.response.data.error_message);
        actions.setSubmitting(false);
      });
  };

  if (isLoading || error) return <Spinner />;
  if (mode === 'display' && !isLoading) {
    return (
      <div>
        <div css={user_block_panel_title}>User Details</div>
        <Link css={userBlock__buttongroup__right} onClick={showEdit}>
          Edit
        </Link>
        <UserDisplay
          firstName={user.first_name}
          lastName={user.last_name}
          companyName={user.company_name}
          email={user.email_address}
          email_verified={
            user.email_address_verified || user.is_logged_in_user_staff
          }
          phoneNumber={user.phone_number}
          userId={userID}
          staffMode={staffMode}
          displayNotification={displayNotification}
          mfaMethod={user.mfa_method}
        />
      </div>
    );
  }

  return (
    <div>
      <div css={user_block_panel_title}>Edit User Details</div>
      <UserEditForm
        initialValues={formValues}
        onCancel={handleCancel}
        onSave={postUserDetails}
      />
    </div>
  );
};

export default UserBlock;
